// 15 distinct colors generated by http://tools.medialab.sciences-po.fr/iwanthue/
export var distinctPalette = [
    '#394C5A',
    '#64B09E',
    '#E8C962',
    '#D47E4D',
    '#CF6250',
    '#587D9E',
    '#7AD8C2',
    '#FFC969',
    '#D85954',
    '#A97BF0',
    '#64BDD9',
    '#86E289',
    '#6091F0',
    '#FD5D5D',
    '#FF7B02',
    '#8399B1',
];
// ima jednu viska
export var colorblindPalette = [
    '#056efe',
    '#61b24a',
    '#ea0902',
    '#f1e77a',
    '#d077e1',
    '#6a7b34',
    '#36051f',
    '#53af89',
    '#98003b',
    '#00beff',
    '#ffffc7',
    '#50377c',
    '#954f6a',
    '#cd8ac7',
    '#e18084',
    '#f9c5de',
];
export var ChartType = {
    LINE: 0,
    BAR: 1,
    AREA: 2,
};
export var chartTypeOptions = [
    {
        value: ChartType.LINE,
        label: 'Line',
    },
    {
        value: ChartType.BAR,
        label: 'Bar',
    },
    {
        value: ChartType.AREA,
        label: 'Area',
    },
];
export var stackedOptions = [
    {
        label: 'Not stacked',
        symbol: 'circle',
        value: 0,
    },
    {
        label: 'Stacked group 1',
        symbol: 'diamond',
        value: 1,
    },
    {
        label: 'Stacked group 2',
        symbol: 'square',
        value: 2,
    },
    {
        label: 'Stacked group 3',
        symbol: 'triangleUp',
        value: 3,
    },
    {
        label: 'Stacked group 4',
        symbol: 'triangleDown',
        value: 4,
    },
];
export var exportOptions = {
    SVG: 0,
    PNG: 1,
    JPEG: 2,
};
export function getTextWidth(text, fontSize, fontFace) {
    var a = document.createElement('canvas');
    var b = a.getContext('2d');
    if (b !== null) {
        b.font = "".concat(fontSize, " ").concat(fontFace);
        return b.measureText(text).width;
    }
    else {
        return 0;
    }
}
